import axios from "axios";
var CryptoJS = require("crypto-js");

class DataAPI {

    constructor() {
        this.URL = "https://" + process.env.VUE_APP_MAIN_URL + "/api/emailVisualisation";
        this.cryptageKey = "2687da56-4181-48a6-bec4-c526727423f8"
    }

    encrypt(datas) {
        return { data: CryptoJS.AES.encrypt(JSON.stringify(datas), this.cryptageKey).toString() }
    }

    decrypt(data) {
        var bytes = CryptoJS.AES.decrypt(data, this.cryptageKey);
        var originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return originalData
    }

    sendinBlue_user_get_info(user_id, callback) {
        let datas = { user_id }
        axios.post(this.URL + '/v1/sendinBlue_user_get_info', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        }).then(res => {
            callback(this.decrypt(res.data));
        })
    }

    sendinBlue_get_emails_list(email, callback) {
        let datas = { email }
        axios.post(this.URL + '/v1/sendinBlue_get_emails_list', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        }).then(res => {
            callback(this.decrypt(res.data));
        })
    }

}
export default new DataAPI()